<template>
    <div class="jr-component">
      <div :class="!components.controlRighttype ? 'jr-buttongroup' : ''">
        <el-dropdown :split-button="true" v-bind="$attrs" :id="components.controlId" :type="type" :disabled="!components.controlRighttype || components.controlReadonly" :size="size" @click="click" trigger="click">
          <i :class="icon"></i><span ><slot></slot></span>
          <el-dropdown-menu slot="dropdown">
            <div @click="itemClick" v-for="(item,i) in items" v-bind:key="item" :id="i"><el-dropdown-item :disabled="!components.controlRighttype">{{ item }}</el-dropdown-item></div>
          </el-dropdown-menu>
        </el-dropdown>
        </div>
        <i @click="rightClick" v-if="badge & components.controlRighttype" class="el-icon-success jr-right-ico" style="color: green;"/>
        <i @click="rightClick" v-if="badge & !components.controlRighttype" class="el-icon-error jr-right-ico" style="color: red;"/>      
    </div>
</template>
<script>
import store from '@/store'
export default {
  name: 'JrButtongroup',
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {},
    items: {},
    size: {
      type: String,
      default: 'small'
    },
    type: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    rightClick(){
      this.$emit('badge-click', this.components.controlId, !this.components.controlRighttype)
    },
    click(){
      this.$emit('click')
    },
    itemClick(e) {
      //console.log(e.currentTarget.id)
      const id = e.currentTarget.id
      this.$emit('click_'+id)
    }
  }
}
</script>
<style scoped lang="scss">
  .jr-buttongroup:hover{
    cursor: not-allowed;
  }
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrButtongroup.vue